import React from "react";
import { useFormField } from "./form";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export const TranslatedFormMessage = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => {
  const { error, formMessageId } = useFormField();
  const body = error ? String(error?.message) : children;
  const { t } = useTranslation();

  if (!body) {
    return null;
  }

  return (
    <p
      ref={ref}
      id={formMessageId}
      className={cn("text-[0.8rem] font-medium text-destructive", className)}
      {...props}
    >
      {t(body.toString())}
    </p>
  );
});
TranslatedFormMessage.displayName = "TranslatedFormMessage";
